import React, { useState, useContext } from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, ThemeProvider, Button, Backdrop, CircularProgress} from '@mui/material';
import {theme, TokenContext} from '../App';
import { API } from '../conf';

export default function Import(props) {
    const [token, setToken] = useContext(TokenContext)
    const [loading, setLoad] = useState(false)
    const [msg, setMsg] = useState(props.msg)

    const handleEnregistrer = ()=>{
        setLoad(true)
        fetch(API.concat('/utilisateurs/registe_many'),{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(props.users).toLowerCase()
        })
        .then(response => {
            if (response.status === 200) {
                response.json()
                .then(json =>{
                    const new_data = json.concat(props.old)
                    props.updateData(new_data)
                    props.show(false)
                })
            } else if (response.status === 401) {
                setToken()
            } else {
                setMsg("Oups! échec de l'enregistrement, veuillez réessayer ultérieurement")
            } 
        })
    }

    return(
        <ThemeProvider theme={theme}>
        {props.users ?
        <div style={{display: 'flex', justifyContent:'center', flexDirection: 'column'}}>
            <TableContainer sx={{ padding:'15px'}}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead component={Paper} elevation={4}>
                    <TableRow>
                        <TableCell align='center'><span style={{fontWeight:'bold'}}>Nom</span></TableCell>
                        <TableCell align="center"><span style={{fontWeight:'bold'}}>Prénom</span></TableCell>
                        <TableCell align="center"><span style={{fontWeight:'bold'}}>Mail</span></TableCell>
                        <TableCell align="center"><span style={{fontWeight:'bold'}}>Département</span></TableCell>
                    </TableRow>
                    </TableHead>

                    <TableBody>
                    {props.users.map((row) => (
                        <TableRow
                        key={row._id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell align='center' ><span style={{textTransform: 'capitalize'}}>{row.nom}</span></TableCell>
                        <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{row.prenom}</span></TableCell>
                        <TableCell align="center"><span style={{textTransform: 'lowercase'}}>{row.mail}</span></TableCell>
                        <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{row.departement}</span></TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table> 
            </TableContainer>
            <div style={{display: 'flex', justifyContent: 'center', flexDirection:'row'}}>
                <Button variant='contained' style={{marginRight:20}} color='grey' onClick={()=> props.show(false)}>Annuler</Button>
                <Button variant='contained' color='verdigris' onClick={handleEnregistrer}>Enregistrer</Button>
            </div>
            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            >
                <CircularProgress color="verdigris" />
            </Backdrop>
        </div>
        : <div style={{minHeight:260, minWidth:500}}>
            <Typography variant='subtitle1' fontWeight='bold' textAlign={'center'} style={{color: 'coral'}}>{props.msg}</Typography>
            {msg.toLowerCase().includes('entêtes invalides') && <><Typography>Les entêtes valides sont les suivants: 'nom', 'prenom', 'mail', 'departement'</Typography>
            <Typography fontWeight='bold'>Sensible à la casse, Attention aux accents !</Typography></>}
        </div>}
        </ThemeProvider>
    )
}